export default __webpack_public_path__ + "static/media/AvatarKids-12.5b6c6c6d.png";